import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { PasswordResetActions } from 'Redux/modules/passwordReset/actions';
import { PasswordResetSelectors } from 'Redux/modules/passwordReset/selectors';
import AppConfig from 'Config/AppConfig';
import { errorMessage } from './errorMessages';
import ResetSent from './ResetSent';
import c from '../../../Components/AuthLayout/authContent.module.less';

const CONTACT_EMAIL = 'support@pipl.com';

// Ported from accounts/templates/pages/password_reset/password_reset.html
// When sent === true, renders the ResetSent confirmation inline.
export function RequestReset() {
  const dispatch = useDispatch();
  const isSubmitting = useSelector(PasswordResetSelectors.passwordResetIsSubmittingSelector);
  const sent = useSelector(PasswordResetSelectors.passwordResetSentSelector);
  const error = useSelector(PasswordResetSelectors.passwordResetErrorSelector);

  const [email, setEmail] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);

  if (sent) {
    return <ResetSent email={email} />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    // Fall back to the live input value so password-manager autofill (which can
    // skip React's onChange) is still picked up.
    const emailValue = email || e.target.elements.email?.value || '';
    dispatch(PasswordResetActions.requestReset({ email: emailValue, captcha: captchaToken }));
  };

  return (
    <>
      <h1 className={c.title}>Reset your password</h1>
      <p className={c.text}>Enter your email address and we&apos;ll send you a link to reset your password.</p>

      <form id="signup_form" onSubmit={handleSubmit} autoCapitalize="off" autoCorrect="off">
        <div className={c.field}>
          <label htmlFor="id_email" className={c.label}>
            Work email
          </label>
          <input
            className={c.input}
            id="id_email"
            name="email"
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div className={c.captcha}>
          <ReCAPTCHA
            sitekey={AppConfig.RECAPTCHA_KEY || (window.__CONFIG__ && window.__CONFIG__.RECAPTCHA_KEY) || ''}
            onChange={(token) => setCaptchaToken(token)}
          />
        </div>

        {error && <div className={c.error}>{errorMessage(error)}</div>}

        <button type="submit" className={c.btnPrimary} disabled={isSubmitting}>
          Reset password
        </button>
      </form>

      <p className={c.text} style={{ marginTop: 20 }}>
        Trouble resetting your password? Contact us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </>
  );
}

export default RequestReset;
